exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n.v-virtual-table {\n  position: relative;\n}\n\n.v-virtual-table__wrapper {\n  display: flex;\n}\n\n.v-virtual-table__table {\n  width: 100%;\n  height: 100%;\n  overflow-x: auto;\n}", ""]);

